<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Orders",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Orders",
            items: [
               {
                  text: "Orders",
                  active: true,
               },                   
            ],

            orders: [],          
            pagination: {},

            listing_length: 10,
            keyword: '',
            order_status: 'pending',
            token: "",
            errors: {},          
            active_page_url: null,
         };
      },
      mounted() {
    
      },
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'pharmacy.orders.add' }" class="btn btn-primary float-end">Add Order</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword"/>
                           </label>
                        </div> 

                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="order_status">
                                 <option value="pending">Pending</option>
                                 <option value="dispatched">Dispatched</option>
                                 <option value="completed">Completed</option>
                              </select>
                           </label>
                        </div>                         
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th width="10%">Patient</th>                 
                              <th width="15%">Contact</th>
                              <th width="10%">Amount</th>
                              <th width="15%">Delivery Type</th>  
                              <th width="20%">Delivery Date</th>  
                              <th width="15%">Created On</th>
                              <th width="15%">Options</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr>
                              <td>Peter John</td>                       
                              <td>
                                 +91 9110011001<br>
                                 peter@xyz.com<br>
                              </td>
                              <td>Rs. 1500</td>
                              <td>Regular</td>                 
                              <td>10 Mar 2022</td>
                              
                              <td>05 Mar 2021, 09:30 am</td>
                             
                              <td>

                                 <router-link :to="{ name: 'pharmacy.orders.details' }" class="btn btn-primary me-2 mb-2 btn-sm">Details</router-link>

                                 <router-link :to="{ name: 'pharmacy.orders.reorder' }" class="btn btn-primary me-2 mb-2 btn-sm">Reorder</router-link>

                                 <b-button v-if="order_status=='pending'" variant="primary" class="me-2 mb-2 btn-sm" >Dispatch Order</b-button>   
                                 
                                 <b-button v-if="order_status=='dispatched'" variant="primary" class="me-2 mb-2 btn-sm" >Complete Order</b-button>   
                                
                              </td>
                           </tr>
                 
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->     
                  <caption class="float-start mt-4 d-block d-lg-inline">Showing 1 to 10 of 26 entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item disabled">
                        <a href="#" class="page-link">
                           <i class="mdi mdi-chevron-left"></i>
                        </a>
                     </li>
                     <li class="page-item">
                        <a href="#" class="page-link">1</a>
                     </li>
                     <li class="page-item active">
                        <a href="#" class="page-link">2</a>
                     </li>
                     <li class="page-item">
                        <a href="#" class="page-link">3</a>
                     </li>
                     
                     <li class="page-item">
                        <a href="#" class="page-link">
                           <i class="mdi mdi-chevron-right"></i>
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
